module.exports = __webpack_public_path__ + "static/img/map0309.de42282.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/map0309.jpg
// module id = ItLR
// module chunks = 0